<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button" (click)="createForm();">Chiudi</button>
		</p>
		<div>
			<div class="col-sm-12 coldx">
        <h3 class="title1level" style="margin-bottom: 20px;">Aggiungi patologia</h3>
        <ng-template [ngIf]="inserimento">
          <div class="col-sm-12 coldx" 
              [ngStyle]="{ 'display' : ( visibleToggleAssocia ? 'block' : 'none') }">
              <form class="cerca_grey">
                  <div class="row">
                      <p class="col-sm-12">
                          <label for="cerca_src_lbl">Cerca</label> <input id="cerca_src_lbl" type="text" #searchItem (keyup)="0"
                              class="form-control" placeholder="Inserisci nome e cognome" />
                      </p>
                  </div>
              </form>
              <ng-template [ngIf]="contropartiAll.length > 0">
              <ul id="controparticollapse" class="controparti">
                  <ng-template ngFor
                      let-controparte [ngForOf]="contropartiAll  | searchFilter : searchItem.value : 'parte.nominativo' ">
      
                  <li class="panel">
                      <div class="controparte">
                        <div>
                          <p class="col-sm-1">
                            <button class="btn btn-primary associa"
                                (click)="associaControparte(controparte);" type="submit">Associa</button>
                        </p>
                          <!-- intestazione nome e cognome o denominazione -->
                          <h4 class="titolo col-sm-3" *ngIf="controparte.parte?.nominativo">
                           &nbsp; &nbsp; {{controparte.parte?.nominativo}}
                          </h4>
                          <h4 class="titolo col-sm-3" *ngIf="!controparte.parte?.nominativo && controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
                            &nbsp; &nbsp; {{controparte.parte?.cognome + ' ' + controparte.parte?.nome}}
                          </h4>
                          <h4 class="titolo col-sm-3" *ngIf="!controparte.parte?.nominativo && controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
                            &nbsp; &nbsp; {{controparte.parte?.ragioneSociale}}
                          </h4>
                          <!--<h4 class="titolo col-sm-4">{{ controparte.parte.nominativo }}</h4>-->
                          <ng-template [ngIf]="controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
                          <p class="col-sm-3">
                            C/F: <strong> {{ controparte.parte.codiceFiscale }} </strong>
                          </p>
                          <p class="col-sm-3">
                            MAT: <strong> {{ controparte.parte.matricola }} </strong>
                          </p>
                          </ng-template>
                          <ng-template
                            [ngIf]="controparte.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
                          <p class="col-sm-3">
                            P.IVA: <strong> {{ controparte.parte.partitaIva }} </strong>
                          </p>
                          </ng-template>
                          <ng-template [ngIf]="controparte.ritirato">
                          <p class="col-sm-2 status">Rinunciatario</p>
                          </ng-template>
                        </div>
                      </div>
                  </li>
                  </ng-template>
              </ul>
              </ng-template>
              <ng-template [ngIf]="contropartiAll.length == 0 && msgNoBeneficiari">
              <p>{{msgNoBeneficiari}}</p>
              </ng-template>
          </div>
          </ng-template>
        <ng-template [ngIf]="patologiaForm">
          <div class="col-sm-12 coldx" id="pannello01"
              [ngStyle]="{ 'display' : ( visibleToggleForm ? 'block' : 'none') }">
            <form #f="ngForm" [formGroup]="patologiaForm" (ngSubmit)="update();">
            <div class="row">

              <div textInput [control]="patologiaForm.controls['patologia']"
                   [checkFormat]="true" class="col-sm-4" [labelInput]="'Patologia'"
                   formControlName="patologia"
                   [mandatory]="true"
                   [(ngModel)]="request.patologia"></div>

              <div datePickerInput class="col-sm-4"
                   [labelInput]="'Data diagnosi'" formControlName="dataDiagnosi" [dataAl]="today"
                   [mandatory]="true"
                   [(ngModel)]="request.dataDiagnosi"></div>

              <div datePickerInput class="col-sm-4" [dataDal]="request.dataDiagnosi"
                   [labelInput]="'Data decesso'" formControlName="dataDecesso"
                   [(ngModel)]="request.dataDecesso"></div>
            </div>

            <div class="row">

              <div checkBoxRadio class="col-sm-4"
                   [labelInput]="'Riconoscimento malattia professionale'" idInput="riconoscimentoMalattiaProfessionale"
                   [mandatory]="true"
                   formControlName="riconoscimentoMalattiaProfessionale" [objectReference]="request.riconoscimentoMalattiaProfessionale"
                   (onReturn)="changeRiconoscimentoMalattiaProfessionale($event); request.riconoscimentoMalattiaProfessionale = $event"></div>

              <div datePickerInput class="col-sm-4"
                   [labelInput]="'Data riconoscimento'" formControlName="dataRiconoscimento"
                   [mandatory]="!!request.riconoscimentoMalattiaProfessionale"
                   [submitPending]="!request.riconoscimentoMalattiaProfessionale"
                   [(ngModel)]="request.dataRiconoscimento"></div>

              <div textInputCurrency class="col-sm-4"	[control]="patologiaForm.controls['percentualeInvalidita']"
                   [labelInput]="'% invalidità'" [maxValue]="100"
                   [isNaturalNumber]="true" [location]="'SezioneEconomica'"
                   formControlName="percentualeInvalidita" [(ngModel)]="request.percentualeInvalidita"></div>
            </div>

            <div class="row">
              <div textAreaInput class="col-sm-12" [labelInput]="'Note'"
                   formControlName="note" [(ngModel)]="request.note"></div>
            </div>
            <div class="row">
              <p class="mandatory col-sm-12">
                <em>* Campi obbligatori</em>
              </p>
            </div>
            <div class="row">
              <p class="col-sm-3 col-xs-6">
                <button type="button" class="btn btn-outline-secondary btn-block"
                        (click)="createForm();">Reset</button>
              </p>
              <p
                submitButton [disabled]="!patologiaForm.valid"
                class="col-sm-3 col-xs-6 col-sm-offset-6"
                [labelButton]="'Salva'"></p>
            </div>
          </form>
        </div>
        </ng-template>
			</div>
		</div>
	</div>
</div>
